// extracted by mini-css-extract-plugin
export default {"panel":"GeneralTabPanel_panel__38FRG","mobile":"GeneralTabPanel_mobile__3hOut","divider":"GeneralTabPanel_divider__1y4re"};